var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon52BlogMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1zm0 5a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1zm1 4a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H5z",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxwYXRoIGQ9Ik00IDdhMSAxIDAgMCAxIDEtMWgxNGExIDEgMCAxIDEgMCAySDVhMSAxIDAgMCAxLTEtMXptMCA1YTEgMSAwIDAgMSAxLTFoMTRhMSAxIDAgMSAxIDAgMkg1YTEgMSAwIDAgMS0xLTF6bTEgNGExIDEgMCAxIDAgMCAyaDE0YTEgMSAwIDEgMCAwLTJINXoiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPg0KPC9zdmc+DQo=";
export { SvgIcon52BlogMenu as ReactComponent };